// src/components/LanguageSwitcher.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  // List of supported languages
  const languages = [
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  ];

  // If i18n.language is something like "en-US", we just take "en"
  const currentLanguage = i18n.language.substring(0, 2);

  // Handle mouse entering the link to open the menu
  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close the menu (called when leaving the menu or selecting a language)
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Switch language and close the menu
  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    handleClose();
  };

  return (
    <>
      {/* 
        Render a span with the same "burger-link" class used for other 
        header links so it matches your existing styling exactly.
      */}
      <span
        className="burger-link"
        onMouseEnter={handleMouseEnter}
        style={{ cursor: 'pointer' }}
      >
        {t("header.language")}
      </span>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        // Automatically close the menu if the mouse leaves the dropdown
        MenuListProps={{
          onMouseLeave: handleClose,
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            disabled={lang.code === currentLanguage}
          >
            <ListItemIcon>
              <span role="img" aria-label={lang.label}>{lang.flag}</span>
            </ListItemIcon>
            <ListItemText primary={lang.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
